import { req } from 'react-reqq-lite';
import { MERCHANT_FILTER } from 'core-modules/merchants/constants';
import { listMerchants, selectMerchant } from 'core-modules/merchants/actions';
import { stringToObject } from 'helper';
import * as t from './transformers';
import * as c from './constants';

export const promiseGetGeneralInfo = (account_id) =>
  new Promise((resolve) => {
    req.get({
      key: c.GENERAL_INFO,
      url: `/profile/v1/my/onboarding/${account_id}/general`,
      transform: (res) => t.transformGeneralInfo(res?.data || {}),
      onSuccess: (res) =>
        resolve(t.transformGeneralInfo(res?.response?.data || {})),
    });
  });

export const saveGeneralInfo = (account_id, payload, onSuccess, onError) => {
  req.put({
    key: c.GENERAL_INFO,
    url: `/profile/v1/my/onboarding/${account_id}/general`,
    payload,
    onSuccess: (res, state) => {
      const arg = {
        ...payload,
        logo: stringToObject(payload?.logo) || [],
      };
      req.set(c.GENERAL_INFO, { ...state[c.GENERAL_INFO], ...arg });
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError,
  });
};

export const checkSavedBusinessInfo = (account_id) => {
  req.get({
    key: c.CHECK_SAVED_BUSINESS_INFO,
    url: `/profile/v1/my/onboarding/${account_id}/check`,
    transform: (res) => t.transformCheckSavedBusinessInfo(res?.data || {}),
  });
};

export const promiseGetBusinessCorporation = (account_id) =>
  new Promise((resolve) => {
    req.get({
      key: c.BUSINESS_INFO,
      url: `/profile/v1/my/onboarding/${account_id}/corporate`,
      transform: (res) => t.transformBusinessCorporation(res?.data || {}),
      onSuccess: (res) =>
        resolve(t.transformBusinessCorporation(res?.response?.data || {})),
    });
  });

export const saveBusinessCorporation = (
  account_id,
  payload,
  onSuccess,
  onError
) => {
  req.put({
    key: c.BUSINESS_INFO,
    url: `/profile/v1/my/onboarding/${account_id}/corporate`,
    payload,
    onSuccess: (res, state) => {
      const arg = {
        ...payload,
        owner_id_image_url: stringToObject(payload?.owner_id_image_url),
        cert_of_corporation_imge_url: stringToObject(
          payload?.cert_of_corporation_imge_url
        ),
        form_x_image_url: stringToObject(payload?.form_x_image_url),
        business_local_director_ic_image_url: stringToObject(
          payload?.business_local_director_ic_image_url
        ),
      };
      req.set(c.BUSINESS_INFO, { ...state[c.BUSINESS_INFO], ...arg });
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError,
  });
};

export const promiseGetBusinessSole = (account_id) =>
  new Promise((resolve) => {
    req.get({
      key: c.BUSINESS_INFO,
      url: `/profile/v1/my/onboarding/${account_id}/sole`,
      transform: (res) => t.transformBusinessSole(res?.data || {}),
      onSuccess: (res) =>
        resolve(t.transformBusinessSole(res?.response?.data || {})),
    });
  });

export const saveBusinessSole = (account_id, payload, onSuccess, onError) => {
  req.put({
    key: c.BUSINESS_INFO,
    url: `/profile/v1/my/onboarding/${account_id}/sole`,
    payload,
    onSuccess: (res, state) => {
      const arg = {
        ...payload,
        owner_id_image_url: stringToObject(payload?.owner_id_image_url),
        business_cert_image_url: stringToObject(
          payload?.business_cert_image_url
        ),
        business_local_owner_ic_image_url: stringToObject(
          payload?.business_local_owner_ic_image_url
        ),
      };
      req.set(c.BUSINESS_INFO, { ...state[c.BUSINESS_INFO], ...arg });
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError,
  });
};

export const promiseGetBusinessIndividual = (account_id) =>
  new Promise((resolve) => {
    req.get({
      key: c.BUSINESS_INFO,
      url: `/profile/v1/my/onboarding/${account_id}/individual`,
      transform: (res) => t.transformBusinessIndividual(res?.data || {}),
      onSuccess: (res) =>
        resolve(t.transformBusinessIndividual(res?.response?.data || {})),
    });
  });

export const saveBusinessIndividual = (
  account_id,
  payload,
  onSuccess,
  onError
) => {
  req.put({
    key: c.BUSINESS_INFO,
    url: `/profile/v1/my/onboarding/${account_id}/individual`,
    payload,
    onSuccess: (res, state) => {
      const arg = {
        ...payload,
        owner_id_image_url: stringToObject(payload?.owner_id_image_url),
        business_local_owner_ic_image_url: stringToObject(
          payload?.business_local_owner_ic_image_url
        ),
      };
      req.set(c.BUSINESS_INFO, { ...state[c.BUSINESS_INFO], ...arg });
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError,
  });
};

export const promiseGetBusinessPartner = (account_id) =>
  new Promise((resolve) => {
    req.get({
      key: c.BUSINESS_INFO,
      url: `/profile/v1/my/onboarding/${account_id}/partnership`,
      transform: (res) => t.transformBusinessPartner(res?.data || {}),
      onSuccess: (res) =>
        resolve(t.transformBusinessPartner(res?.response?.data || {})),
    });
  });

export const saveBusinessPartner = (
  account_id,
  payload,
  onSuccess,
  onError
) => {
  req.put({
    key: c.BUSINESS_INFO,
    url: `/profile/v1/my/onboarding/${account_id}/partnership`,
    payload,
    onSuccess: (res, state) => {
      req.set(c.BUSINESS_INFO, { ...state[c.BUSINESS_INFO], ...payload });
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError,
  });
};

export const getBusinessGovernment = (account_id, onSuccess) => {
  req.get({
    key: c.BUSINESS_INFO,
    url: `/profile/v1/my/onboarding/${account_id}/government`,
    transform: (res) => t.transformBusinessGovernment(res?.data || {}),
    onSuccess: (res) =>
      onSuccess(t.transformBusinessGovernment(res?.response?.data || {})),
  });
};

export const saveBusinessGovernment = (
  account_id,
  payload,
  onSuccess,
  onError
) => {
  req.put({
    key: c.BUSINESS_INFO,
    url: `/profile/v1/my/onboarding/${account_id}/government`,
    payload,
    onSuccess: (res, state) => {
      const arg = {
        ...payload,
        owner_id_image_url: stringToObject(payload?.owner_id_image_url),
        ministry_appointment_letter_img_url: stringToObject(
          payload?.ministry_appointment_letter_img_url
        ),
        ministry_letter_for_appointed_img_url: stringToObject(
          payload?.ministry_letter_for_appointed_img_url
        ),
        ic_authorised_person_img_url: stringToObject(
          payload?.ic_authorised_person_img_url
        ),
      };
      req.set(c.BUSINESS_INFO, { ...state[c.BUSINESS_INFO], ...arg });
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError,
  });
};

export const submitApplication = (account_id, payload, onSuccess, onError) => {
  req.put({
    key: c.APPLICATION,
    url: `/profile/v1/my/onboarding/${account_id}/submit_application`,
    payload,
    onSuccess: (res, state) => {
      selectMerchant(account_id);
      listMerchants(state[MERCHANT_FILTER]);
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError,
  });
};
